import React from 'react';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import { v4 as uuid } from 'uuid';
import CardTitle from 'app/components/CardTitle';
import { _t } from 'app/utils/i18n';

export const platformsComp = ({ value }: Record<string, any>): JSX.Element => {
  return (
    <div style={{ display: 'flex', textAlign: 'center' }}>
      {value.map((v: any): JSX.Element => renderIcon(v.name))}
      {<CardTitle compId="" title={``} />}
    </div>
  );
};
export const headerCell = (
  name: string,
  module = 'influencers'
): JSX.Element => {
  return (
    <div style={{ display: 'inline-flex' }}>{_t(`${module}:${name}`)}</div>
  );
};

const renderIcon = (name: string): JSX.Element => (
  <React.Fragment key={uuid()}>
    {name === _t('trends:facebook') && <FacebookIcon />}
    {name === _t('trends:twitter') && <TwitterIcon />}
    {name === _t('trends:youtube') && <YouTubeIcon />}
    {name === _t('trends:instagram') && <InstagramIcon />}
  </React.Fragment>
);
export const textIcon = (prop: Record<string, any>): JSX.Element => {
  const { value } = prop;
  return (
    <>
      <CardTitle title={`${value}`} compId={''} />
    </>
  );
};
